<template>
    <div class="sc-message--text bot-file-message">
        <div class="media-content-wrapper">
            <a :href="fileSrc()" download target="_blank">
                <div v-if="getFile(fileSrc())" :class="`fi-${getFile(fileSrc())}`" class="fi">
                    <div class="fi-content">{{ getFile(fileSrc()) }}</div>
                </div>
                <p class="media-content-text">
                    {{ $t("message.download") }}
                </p>
            </a>
        </div>
        <span v-if="data.data.meta" class="sc-message--meta">{{ data.data.meta }}</span>
    </div>
</template>

<script>
import { getExtensionFromFileName } from "../../../../../utils/utils";

export default {
    name: "BotFileMessage",
    props: ["data"],
    data() {
        return {
            previewImg: false,
            hovered: false,
        };
    },
    methods: {
        getFile(fileName) {
            return getExtensionFromFileName(fileName);
        },
        fileSrc() {
            const a = this.data.raw;
            return `${a.payload}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~css-file-icons";

.bot-file-message {
    //position: relative;
    //border: 1px solid #66666626;
    //padding: 10px;
    margin: 4px;

    //.media-content-text {
    //    margin-bottom: 0;
    //    margin-top: 4px;
    //}

    .message {
        margin: 18px 6px;
        border-radius: var(--sps-radius-sm);
    }

    .media-content-wrapper {
        margin: 4px;

        .media-content-text {
            margin-bottom: 0;
            font-family: Poppins, monospace;
            margin-top: 6px;
            font-size: 12px;
            font-weight: 400;
            text-align: center;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/messages/chatbot/BotFileMessage.vue